// Keep journal failures isolated from authorized business-state loading.
const createAccountingJournalLoader = ({ runtime, businessId, getState, starting, loaded, success, failure }) => {
  let generation = 0, pendingKey = '', completeKey = '';
  const load = async (selectedYear, force = false) => {
    const year = Number(selectedYear) || new Date().getFullYear();
    const requestKey = `${runtime.accountingJournalFiscalYear ? 'fiscal' : 'calendar'}:${window.PlummeAccountingJournalPagination.reloadKey(getState(), year)}`;
    if (!force && completeKey === requestKey) { generation++; pendingKey = ''; loaded(); return; }
    if (!force && pendingKey === requestKey) return;
    const current = ++generation;
    pendingKey = requestKey;
    starting();
    try {
      const readPage = runtime.accountingJournalReader || ((body) => authorizedPost('accountingJournalReadHttp', body, { requestTimeoutMs: 10000 }));
      const payload = await window.PlummeAccountingJournalPagination.load({
        readPage: body => readPage({ ...body, ...(runtime.accountingJournalFiscalYear ? { fiscalYear: true } : {}) }), businessId, year,
      });
      if (generation !== current || runtime.activeBusinessId !== businessId) return;
      pendingKey = ''; completeKey = requestKey;
      window.PlummeAccountingJournalRecovery.clear(runtime, businessId);
      success(payload);
    } catch (error) {
      if (generation !== current || runtime.activeBusinessId !== businessId) return;
      pendingKey = ''; completeKey = window.PlummeAccountingJournalRecovery.isAccessError(error) ? '' : requestKey;
      failure(error, year);
    }
  };
  return { load, stop: () => { generation++; }, retry: year => load(year, true) };
};

// Obtain the existing server proof without transferring every journal page.
const createAccountingCoverageLoader = ({ runtime, businessId, getState, starting, success, failure }) => {
  let generation = 0, pending = '', complete = '';
  return {
    async load(year) {
      const key = `${runtime.accountingJournalFiscalYear ? 'fiscal' : 'calendar'}:${window.PlummeAccountingJournalPagination.reloadKey(getState(), year)}`;
      if (pending === key || complete === key) return;
      pending = key;
      starting();
      const version = ++generation;
      try {
        const read = runtime.accountingJournalReader || ((body) => authorizedPost('accountingJournalReadHttp', body, { requestTimeoutMs: 10000 }));
        const scope = { businessId, year, ...(runtime.accountingJournalFiscalYear ? { fiscalYear: true } : {}) };
        const first = await read(scope);
        if (!Number.isInteger(first.journalPage?.taken_at_seq) || first.journalPage.taken_at_seq < 0 || !first.sourceFingerprint) throw new Error(window.t('common.journalProofUnavailable'));
        const payload = await read({ ...scope, finalize: true, expectedWatermark: first.journalPage?.taken_at_seq, expectedSourceFingerprint: first.sourceFingerprint });
        if (payload.finalized !== true || payload.businessId !== businessId || Number(payload.year) !== Number(year) || payload.sourceFingerprint !== first.sourceFingerprint) throw new Error(window.t('common.journalProofUnavailable'));
        if (version !== generation || runtime.activeBusinessId !== businessId || !runtime.journalDeferred) return;
        pending = ''; complete = key; success(payload);
      } catch (error) {
        if (version !== generation || runtime.activeBusinessId !== businessId || !runtime.journalDeferred) return;
        pending = ''; complete = key; failure(error, year);
      }
    },
    stop() { generation++; pending = ''; complete = ''; },
  };
};
